var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25695 18H4.12781C1.85175 18 0 16.1483 0 13.8722V7.9647C0 6.65723 0.628829 5.41423 1.68214 4.6394L6.89347 0.806809C8.35637 -0.269109 10.3219 -0.268764 11.7848 0.806809L16.996 4.63944C17.3034 4.86577 17.3695 5.2983 17.1433 5.606C16.9168 5.91348 16.4843 5.97881 16.1768 5.75334L10.9656 1.92068C9.99261 1.20509 8.68529 1.20509 7.71268 1.92068L2.50139 5.75331C1.8008 6.26839 1.38257 7.0952 1.38257 7.9647V13.8722C1.38257 15.3861 2.6141 16.6174 4.12781 16.6174H9.25695C9.63871 16.6174 9.94823 16.927 9.94823 17.3087C9.94823 17.6905 9.63871 18 9.25695 18Z",
    fill: "#012124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.fc50c830ae9f44ed50d512cf1f4d30b2.svg";
export { ForwardRef as ReactComponent };